import { Outlet, Route } from "react-router-dom";
import { MassCommunicationRoutes } from "./mass-communication/MassCommunicationRoutes";

export const MessagingCenterRoutes = (
  <Route path="messaging-center" element={<Outlet />}>
    {MassCommunicationRoutes}
  </Route>
);
